"use client";

import {
  AD_DETAILS_2_COLUMN_MAX_WIDTH,
  AD_DETAILS_ASIDE_WIDTH,
  AD_DETAILS_BODY_WIDTH,
  AD_DETAILS_BORDER_RADIUS,
  HIDE_SCROLLBAR_STYLE,
  NAV_SELECTED_BACKGROUND_COLOR,
} from "@/app/layout/LayoutConstants";
import SubNav from "@/app/layout/SubNav";
import { Box, styled } from "@mui/material";
import { ReactNode } from "react";
import { DETAILS_ADS } from "../ads";
import AdModule from "@/components/shared/AdModule";

export const AD_DETAILS_DESKTOP_SPACING = 4;
const AD_DETAILS_MOBILE_SPACING = 1;

const HiddenAd = styled(Box)(({ theme }) =>
  theme.unstable_sx({
    height: theme.spacing(4),
    backgroundColor: "grey.100",
    [theme.breakpoints.down(AD_DETAILS_2_COLUMN_MAX_WIDTH)]: {
      display: "none",
    },
  })
);

const AdDetailsGridContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: `minmax(${theme.spacing(2)}, 1fr) minmax(400px, ${AD_DETAILS_BODY_WIDTH}) ${AD_DETAILS_ASIDE_WIDTH} minmax(${theme.spacing(2)}, 1fr)`,
  width: "100%",
  [theme.breakpoints.down(AD_DETAILS_2_COLUMN_MAX_WIDTH)]: {
    gridTemplateColumns: "1fr",
  },
}));

export default function AdDetailsPageLayout({
  nav,
  gallery,
  prebody,
  body,
  footer,
  aside,
  hideAds,
}: {
  nav: ReactNode;
  gallery: ReactNode;
  prebody: ReactNode;
  body: ReactNode;
  footer: ReactNode;
  aside: ReactNode;
  hideAds: boolean;
}) {
  return (
    <Box>
      <SubNav collapseOnScroll>
        <Box
          sx={{
            backgroundColor: NAV_SELECTED_BACKGROUND_COLOR,
          }}
        >
          <AdDetailsGridContainer>
            <Box
              sx={(theme) => ({
                gridColumnStart: "2",
                gridColumnEnd: "4",
                paddingTop: 2.5,
                paddingBottom: 2,
                ...HIDE_SCROLLBAR_STYLE,
                [theme.breakpoints.down(AD_DETAILS_2_COLUMN_MAX_WIDTH)]: {
                  overflowX: "auto",
                  gridColumnStart: "1",
                },
                [theme.breakpoints.down(AD_DETAILS_2_COLUMN_MAX_WIDTH)]: {
                  paddingLeft: AD_DETAILS_MOBILE_SPACING,
                  paddingRight: AD_DETAILS_MOBILE_SPACING,
                },
              })}
            >
              {nav}
            </Box>
          </AdDetailsGridContainer>
        </Box>
      </SubNav>
      {hideAds ? (
        <HiddenAd />
      ) : (
        <AdModule config={DETAILS_ADS.Horsezone_Details_Top} />
      )}
      <AdDetailsGridContainer
        sx={{
          backgroundColor: "grey.100",
        }}
      >
        {gallery}
        <Box
          sx={(theme) => ({
            gridColumn: "2",
            backgroundColor: "white",
            maxWidth: "100vw",
            borderBottomLeftRadius: theme.spacing(AD_DETAILS_BORDER_RADIUS),
            borderBottomRightRadius: theme.spacing(AD_DETAILS_BORDER_RADIUS),
            paddingTop: AD_DETAILS_DESKTOP_SPACING,
            [theme.breakpoints.down(AD_DETAILS_2_COLUMN_MAX_WIDTH)]: {
              gridColumn: "1",
              borderRadius: 0,
            },
          })}
        >
          {prebody}
          <Box
            sx={(theme) => ({
              display: "flex",
              flexDirection: "column",
              paddingBottom: AD_DETAILS_DESKTOP_SPACING,
              paddingLeft: AD_DETAILS_DESKTOP_SPACING,
              paddingRight: AD_DETAILS_DESKTOP_SPACING,
              [theme.breakpoints.down(AD_DETAILS_2_COLUMN_MAX_WIDTH)]: {
                paddingLeft: AD_DETAILS_MOBILE_SPACING,
                paddingRight: AD_DETAILS_MOBILE_SPACING,
                paddingBottom: AD_DETAILS_MOBILE_SPACING,
              },
              height: "100%",
            })}
          >
            {body}
          </Box>
        </Box>
        <Box
          sx={(theme) => ({
            gridColumn: 2,
            display: "flex",
            justifyContent: "flex-end",
            marginTop: 2,
            [theme.breakpoints.down(AD_DETAILS_2_COLUMN_MAX_WIDTH)]: {
              marginTop: 0,
              gridColumn: 1,
              padding: 1,
            },
          })}
        >
          {footer}
        </Box>
        <Box
          sx={(theme) => ({
            gridColumn: 3,
            gridRow: 2,
            padding: theme.spacing(0, AD_DETAILS_DESKTOP_SPACING),
            display: "flex",
            flexDirection: "column",
            gap: 6,
            [theme.breakpoints.down(AD_DETAILS_2_COLUMN_MAX_WIDTH)]: {
              gridColumn: 1,
              gridRow: 3,
              padding: AD_DETAILS_MOBILE_SPACING,
              gap: AD_DETAILS_MOBILE_SPACING,
            },
          })}
        >
          {aside}
        </Box>
      </AdDetailsGridContainer>
      {hideAds ? (
        <HiddenAd />
      ) : (
        <AdModule config={DETAILS_ADS.Horsezone_Details_Bottom} />
      )}
    </Box>
  );
}
